import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { userAction } from "../store/user/user-slice";

const usePageName = () => {
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  let routeName;

  // get page name
  let pageName =
    pathname !== "/" ? pathname.split("/").pop().toLowerCase() : "";

  if (pathname.startsWith("/eventmaster/tournaments")) {
    pageName = "tournaments";
  }

  if (pathname.startsWith("/eventmaster/matches")) {
    pageName = "matches";
  }

  if (pathname.startsWith("/eventmaster/market")) {
    pageName = "market";
  }

  if (pathname.startsWith("/eventmaster/bookmaker")) {
    pageName = "bookmaker";
  }

  if (pathname.startsWith("/eventmaster/fancy")) {
    pageName = "fancy";
  }

  if (pathname.startsWith("/eventmaster/ImportRadheFancy")) {
    pageName = "importradhefancy";
  }

  if (pathname.startsWith("/eventmaster/ImportIndiaFancy")) {
    pageName = "importindiafancy";
  }

  if (pathname.startsWith("/rolemanager/roles")) {
    pageName = "roles";
  }

  if (pathname.startsWith("/config/import")) {
    pageName = "import";
  }

  // store page permission data
  useEffect(() => {
    if (user && user?.role && user?.role?.modules) {
      const matchingModule = user?.role?.modules?.find((role) => {
        if (["image-upload", "payment-gateway"].includes(pageName)) {
          return role?.moduleName.toLowerCase() === "dashboard";
        }

        if (["importindiafancy", "importradhefancy"].includes(pageName)) {
          return role?.moduleName.toLowerCase() === "fancy";
        }

        if (
          [
            "openmarket",
            "settledmarket",
            "cancelmarket",
            "casinomarket",
          ].includes(pageName)
        ) {
          return role.moduleName.toLowerCase() === "opengame";
        }

        if (pageName === "manageusers") {
          return role?.moduleName.toLowerCase() === "user";
        }

        if (["moduleaccess", "roles"].includes(pageName)) {
          return role.moduleName.toLowerCase() === "role";
        }

        if (["import", "importdream"].includes(pageName)) {
          return role.moduleName.toLowerCase() === "import";
        }

        if (pageName === "apisettings") {
          return role?.moduleName.toLowerCase() === "whitelabelsetting";
        }

        return role?.moduleName.toLowerCase() === pageName;
      });

      if (matchingModule) {
        dispatch(userAction.setPagePermissions(matchingModule));
      }
    }
  }, [user, pageName, dispatch]);

  return {
    pageName,
    pathname,
  };
};

export default usePageName;
